export const serviceRoles = {
  account: {
    name: "account",
    roles: {
      any: "any",
      anon: "anon",
      auth: "auth",
      user: "user",
      admin: "admin",
      superadmin: "superadmin",
    },
  },
};
